import Shader from '~/glxp/utils/shader'
import ShaderManifest from '~/glxp/shaderManifest'

import DebugController from '~/glxp/debug/debugController'

import { Transform } from '~/glxp/ogl/core/Transform.js'
import { Plane } from '~/glxp/ogl/extras/Plane.js'
import { Program } from '~/glxp/ogl/core/Program.js'
import { Mesh } from '~/glxp/ogl/core/Mesh.js'
import { Color } from '~/glxp/ogl/math/Color'

// Data
import { GUI_PANEL_CUSTOM } from '~/glxp/data/dataGUIPanels'

class ExperienceEarthGlowTopEntity {
  constructor(
    scene,
    {
      id = 0,
      parent = null,
      scale = 1,
      blendFunc = {
        src: scene.gl.SRC_ALPHA,
        dst: scene.gl.DST_ALPHA,
        // dst: scene.gl.DST_ALPHA,
      },
      transparent = true,
      depthTest = false,
      depthWrite = true,
      renderOrder = 0.5,
      name = 'Experience Earth Glow Top'
    } = {}
  ) {
    this.groupId = id
    this.gl = scene.gl
    this.scene = scene
    this.parent = parent ? parent : scene.root
    this.scale = scale
    this.transparent = transparent
    this.blendFunc = blendFunc
    this.depthTest = depthTest
    this.depthWrite = depthWrite
    this.renderOrder = renderOrder
    this.name = name

    // Shader
    this.shaderGlow = new Shader(ShaderManifest['experienceGlowTop'])

    this.config = {
      RimColor: { value: '#c1daf2', params: { }  },
      RimAlpha: { value: 0.8, params: {  min: 0, max: 1, step: 0.01  }  },
      Position: { value: 0.541, params: {  min: 0.5, max: 0.6, step: 0.0001  }  },
      LengthInner: { value: 0.003, params: {  min: 0, max: 0.2, step: 0.001  }  },
      LengthOuter: { value: 0.0135, params: {  min: 0, max: 0.2, step: 0.001  }  }
    }

    this.initGlow()
  }

  initGui(){
    this.gui = DebugController.addBlade(this.config, `${this.scene.name} - ${this.name}`, GUI_PANEL_CUSTOM)
  }

  initGlow() {
    this.geometry = new Plane(this.gl, { width: 5, height: 5 })

    this.program = new Program(this.gl, {
      vertex: this.shaderGlow.vert,
      fragment: this.shaderGlow.frag,
      uniforms: {
        uTime: { value: this.scene.time }, 
        uCamera: { value: this.scene.camera.worldPosition },
        uColorRim: { value: new Color(this.config.RimColor.value) },
        uAlphaRim: this.config.RimAlpha,
        uPosition: this.config.Position,
        uLengthInner: this.config.LengthInner,
        uLengthOuter: this.config.LengthOuter,
      },
      transparent: true,
      depthTest: this.depthTest,
      depthWrite: this.depthWrite,
      cullFace: false,
    })

    this.program.setBlendFunc(this.blendFunc.src, this.blendFunc.dst)

    this.mesh = new Mesh(this.gl, {
      geometry: this.geometry,
      program: this.program,
      renderOrder: this.renderOrder,
      forceRenderOrder: true,
    })

    this.mesh.scale.set(this.scale, this.scale, this.scale)
    // this.mesh.lookAt(this.scene.camera.worldPosition)
    this.mesh.name = this.name

    this.meshWrapper = new Transform(this.gl)
    this.mesh.setParent(this.meshWrapper)
    this.meshWrapper.setParent(this.parent)
  }

  onLoaded() {
    this.initGui()

    setTimeout(() => {
      this.program.uniforms['uColorRim'].value = new Color(this.config.RimColor.value)
    }, 1);
  }

  preRender() {
    this.program.uniforms["uTime"].value = this.scene.time

    // this.mesh.lookAt(this.scene.camera.worldPosition)

    if (DebugController.active) {
      this.program.uniforms['uColorRim'].value = new Color(this.config.RimColor.value)
    }
  }

  dispose() {
    this.mesh.setParent(null)
    this.geometry.remove()
    this.program.remove()
  }
}

export default ExperienceEarthGlowTopEntity
